import { useNavigate, useParams } from "react-router-dom";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { ACTION_TYPE, REPORT_NAME, REPORT_PATH, USER_TYPE } from "../../constant/reportType";
import { Radio, RadioChangeEvent, Switch, Table } from "antd";
import { AGENT_MASTER_COLUMN, DATA_PIPELINE_CATEGORY_COLUMN, DATA_PIPELINE_COLUMN, DATA_RECORDS_COLUMN, TERM_COLUMN, TERM_SET_COLUMN, VALUE_CHAIN_CATEGORY_COLUMN, VALUE_CHAIN_COLUMN, VALUE_CHAIN_PARAGRAPH_EXTRACT_COLULMN } from "../../constant/AppConstant";
import { BsPencilSquare, BsPlus, BsSearch } from "react-icons/bs";
import { alertMessage } from "../../utils/AlertService";
import MasterReportData from "./MasterReportData";
import { useAppSelector } from "../../redux-toolkit/hooks";
import Loading from "../Loading";
import { useDeleteValueChainByIdMutation, useGetAllValueChainsMutation, useGetAllValueChainsWithSearchMutation } from "../../redux-toolkit/services/allValueChainsService";
import { useDeleteValueChainCategoryByIdMutation, useGetAllValueChainCategoriesMutation, useGetAllValueChainCategoriesWithSearchMutation } from "../../redux-toolkit/services/allValueChainCategoriesService";
import { useDeleteTermByIdMutation, useGetAllTermMutation, useGetAllTermWithSearchMutation } from "../../redux-toolkit/services/allTermService";
import { useDeleteTermSetByIdMutation, useGetAllTermSetMutation, useGetAllTermSetWithSearchMutation } from "../../redux-toolkit/services/allTermSetService";
import { useDeleteDataPipelineCategoryByIdMutation, useGetAllDataPipelinesCategoriesMutation, useGetAllDataPipelinesCategoriesWithSearchMutation } from "../../redux-toolkit/services/allDataPipelinesCategoriesService";
import { useDeleteDataPipelineByIdMutation, useGetAllDataPipelinesMutation, useGetAllDataPipelinesWithSearchMutation } from "../../redux-toolkit/services/allDataPipelinesService";
import { useDeleteDataRecordByIdMutation, useGetAllDataRecordsWithPaginationMutation, useGetAllDataRecordsWithSearchMutation } from "../../redux-toolkit/services/allDataRecordsService";
import { useGetAllValueChainParagraphExtractWithPaginationMutation, useGetAllValueChainParagraphExtractWithSearchMutation } from "../../redux-toolkit/services/allValueChainParagraphExtractService";
import { getAllDataPipelinesCategoriesDetails, getAllDataPipelinesCategoriesDetailsBySearch, getDataPipelineCategoryTotalRecords, setAllDataPipelinesCategories, setAllDataPipelinesCategoriesBySearch } from "../../redux-toolkit/slices/allDataPipelinesCategoriesSlice";
import { getDataPipelinesDetails, getDataPipelinesDetailsBySearch, getDataPipelineTotalRecords, setAllDataPipelines, setAllDataPipelinesBySearch } from "../../redux-toolkit/slices/allDataPipelinesSlice";
import { getAllDataRecordsDetailsBySearch, getAllDataRecordsTotalRecords, getAllDataRecordsWithPaginationDetails, setAllDataRecordsBySearch, setAllDataRecordsWithPagination } from "../../redux-toolkit/slices/allDataRecordsSlice";
import { getAllTermSetDetails, getAllTermSetDetailsBySearch, getTermSetTotalRecords, setAllTermSet, setAllTermSetBySearch } from "../../redux-toolkit/slices/allTermSetSlice";
import { getAllTermDetails, getAllTermDetailsBySearch, getTermTotalRecords, setAllTerm, setAllTermBySearch } from "../../redux-toolkit/slices/allTermSlice";
import { getAllValueChainCategoriesBySearchDetails, getAllValueChainCategoriesDetails, getValueChainCategoriesTotalRecords, setAllValueChainCategories, setAllValueChainCategoriesBySearch } from "../../redux-toolkit/slices/allValueChainCategorySlice";
import { getValueChainParagraphExtractDetailsBySearch, getValueChainParagraphExtractTotalRecords, getValueChainParagraphExtractWithPaginationDetails, setAllValueChainParagraphExtractBySearch, setAllValueChainParagraphExtractWithPagination } from "../../redux-toolkit/slices/allValueChainParagraphExtractSlice";
import { getAllValueChainsDetails, getAllValueChainsDetailsBySearch, getValueChainTotalRecords, setAllValueChains, setAllValueChainsBySearch } from "../../redux-toolkit/slices/allValueChainsSlice";
import { fDateTimeSuffix } from "../utils";
import { useDeleteAgentMasterByIdMutation, useGetAllAgentMasterMutation, useGetAllAgentMasterWithSearchMutation } from "../../redux-toolkit/services/allAgentMasterService";
import { getAgentMasterDetails, getAgentMasterDetailsBySearch, getAgentMasterTotalRecords, setAgentMaster, setAgentMasterBySearch } from "../../redux-toolkit/slices/allAgentMasterSlice";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

type Props = {};
const DataSourceMangement = (props: Props) => {

    const params = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const localUserObj: any = getLocalStorageData("localUser");
    const token: any = getLocalStorageData("localUser").token;

    //state
    const [actionType, setActionType] = useState(ACTION_TYPE.ADD_ACTION) as any;
    const [reportName, setReportName]: any = useState();
    const [currentpage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [show, setShow] = useState(false);
    const [selectedRow, setSelectedRow]: any = useState([]);
    const [columData, setColumnData]: any = useState();
    const [dataSource, setDatasource]: any = useState([]);
    const [call, setCall] = useState("N");
    const [isCategory, setIsCategory] = useState(false);
    const [showAdd, setShowAdd] = useState(true);
    const [exportData, setExportData]: any = useState([]);
    const [searchValue, setSearchValue] = useState(1);
    const [filterTableForDataRecord, setFilterTableForDataRecord] = useState([]);

    //getMutations
    const [getAllAgentMaster, allAgentMasterResponse] = useGetAllAgentMasterMutation();
    const [getAllValueChains, valueChainsResponse] = useGetAllValueChainsMutation();
    const [getAllValueChainCategories, valueChainCategoriesResponse] = useGetAllValueChainCategoriesMutation();
    const [getAllTerm, getAllTermResponse] = useGetAllTermMutation();
    const [getAllTermSet, getTermSetResponse] = useGetAllTermSetMutation();
    const [getAllDataPipelinesCategories, dataPipelinesCategoiresResponse] = useGetAllDataPipelinesCategoriesMutation();
    const [getAllDataPipelines, dataPipelinesResponse] = useGetAllDataPipelinesMutation();
    const [getAllValueChainParagraphExtract, valueChainParagraphExtractResponse] = useGetAllValueChainParagraphExtractWithPaginationMutation();
    const [getAllDataRecords, dataRecordsResponse]: any = useGetAllDataRecordsWithPaginationMutation();

    //search
    const [getAllAgentMasterWithSearch, getAllAgentMasterWithSearchResponse] = useGetAllAgentMasterWithSearchMutation();
    const [getAllDataPipelineWithSearch, getAllDataPipelineWithSearchResponse] = useGetAllDataPipelinesWithSearchMutation();
    const [getAllDataPipelineCategoryWithSearch, getAllDataPipelineCategoryWithSearchResponse] = useGetAllDataPipelinesCategoriesWithSearchMutation();
    const [getAllValueChainWithSearch, getAllValueChainWithSearchResponse] = useGetAllValueChainsWithSearchMutation();
    const [getAllValueChainCategoryWithSearch, getAllValueChainCategoryWithSearchResponse] = useGetAllValueChainCategoriesWithSearchMutation();
    const [getAllTermSetWithSearch, getAllTermSetWithSearchResponse] = useGetAllTermSetWithSearchMutation();
    const [getAllTermWithSearch, getAllTermWithSearchResponse] = useGetAllTermWithSearchMutation();
    const [getAllDataRecordWithSearch, getAllDataRecordWithSearchResponse] = useGetAllDataRecordsWithSearchMutation();
    const [getAllValueChainParagraphExtractWithSearch, getAllValueChainParagraphExtractWithSearchResponse] = useGetAllValueChainParagraphExtractWithSearchMutation();

    //delete mutation
    const [deleteAgentMasterById, deleteAgentMasterByIdResponse] = useDeleteAgentMasterByIdMutation();
    const [deleteValueChainById, deleteValueChainByIdResponse] = useDeleteValueChainByIdMutation();
    const [deleteTerm, deleteTermResponse] = useDeleteTermByIdMutation();
    const [deleteValueChainCategoryById, deleteValueChainCategoryByIdResponse] = useDeleteValueChainCategoryByIdMutation();
    const [deleteTermSet, deleteTermSetResponse] = useDeleteTermSetByIdMutation();
    const [deleteDataPipelineCategoryById, deleteDataPipelineCategoryByIdResponse] = useDeleteDataPipelineCategoryByIdMutation();
    const [deleteDataPipelineById, deleteDataPipelineByIdResponse] = useDeleteDataPipelineByIdMutation();
    const [deleteDataRecord, deleteDataRecordResponse] = useDeleteDataRecordByIdMutation();

    //totalRecords
    const totalAgentMaster: any = useAppSelector(getAgentMasterTotalRecords);
    const totalValueChainCategory: any = useAppSelector(getValueChainCategoriesTotalRecords);
    const totalValueChain: any = useAppSelector(getValueChainTotalRecords);
    const totalDatapipelineCategory: any = useAppSelector(getDataPipelineCategoryTotalRecords);
    const totalDatapipeline: any = useAppSelector(getDataPipelineTotalRecords);
    const totalTermSet: any = useAppSelector(getTermSetTotalRecords);
    const totalTerms: any = useAppSelector(getTermTotalRecords);
    const totalDataRecords: any = useAppSelector(getAllDataRecordsTotalRecords);
    const totalValueChainParagraphExtract: any = useAppSelector(getValueChainParagraphExtractTotalRecords);

    //selector
    const allAgentMaster: any = useAppSelector(getAgentMasterDetails)
    const allAgentMasterBySearch: any = useAppSelector(getAgentMasterDetailsBySearch);
    const allValueChains: any = useAppSelector(getAllValueChainsDetails);
    const allValueChainsBySearch: any = useAppSelector(getAllValueChainsDetailsBySearch);
    const allValueChainCategories: any = useAppSelector(getAllValueChainCategoriesDetails);
    const allValueChainCategoriesBySearch: any = useAppSelector(getAllValueChainCategoriesBySearchDetails);
    const allTerm: any = useAppSelector(getAllTermDetails);
    const allTermBySearch: any = useAppSelector(getAllTermDetailsBySearch);
    const allTermSet: any = useAppSelector(getAllTermSetDetails);
    const allTermSetBySearch: any = useAppSelector(getAllTermSetDetailsBySearch);
    const allDataPipelineCategories: any = useAppSelector(getAllDataPipelinesCategoriesDetails);
    const allDataPipelineCategoriesBySearch: any = useAppSelector(getAllDataPipelinesCategoriesDetailsBySearch);
    const allDataPipeline: any = useAppSelector(getDataPipelinesDetails);
    const allDataPipelineBySearch: any = useAppSelector(getDataPipelinesDetailsBySearch);
    const allValueChainParagraphExtract: any = useAppSelector(getValueChainParagraphExtractWithPaginationDetails);
    const allValueChainParagraphExtractBySearch: any = useAppSelector(getValueChainParagraphExtractDetailsBySearch);
    const allDataRecords: any = useAppSelector(getAllDataRecordsWithPaginationDetails);
    const allDataRecordsBySearch: any = useAppSelector(getAllDataRecordsDetailsBySearch);

    useEffect(() => {
        switch (params.reportType) {
            case REPORT_PATH.AGENT_MASTER:
                setReportName(REPORT_NAME.AGENT_MASTER)
                break;
            case REPORT_PATH.VALUE_CHAIN_CATEGORY:
                setReportName(REPORT_NAME.VALUE_CHAIN_CATEGORY)
                break;
            case REPORT_PATH.VALUE_CHAIN:
                setReportName(REPORT_NAME.VALUE_CHAIN)
                break;
            case REPORT_PATH.DATA_PIPELINE_CATEGORY:
                setReportName(REPORT_NAME.DATA_PIPELINE_CATEGORY)
                break;
            case REPORT_PATH.DATA_PIPELINE:
                setReportName(REPORT_NAME.DATA_PIPELINE)
                break;
            case REPORT_PATH.TERM_SET:
                setReportName(REPORT_NAME.TERM_SET)
                break;
            case REPORT_PATH.TERM:
                setReportName(REPORT_NAME.TERM)
                break;
            case REPORT_PATH.DATA_RECORD:
                setReportName(REPORT_NAME.DATA_RECORD)
                break;
            case REPORT_PATH.VALUE_CHAIN_PARAGRAPH_EXTRACT:
                setReportName(REPORT_NAME.VALUE_CHAIN_PARAGRAPH_EXTRACT)
                break;
            default:
        }
    }, [params.reportType]);

    useEffect(() => {
        const temp: any = [];
        const tempAction: any = {
            title: "Action",
            dataIndex: "action",
            key: "name",
            fixed: "right",
            width: 120,
            render: (index: any, record: any) => {
                return (
                    // for delete switch button
                    <div className="d-flex justify-content-between">
                        <div className="px-2 pe-auto">
                            <Switch
                                className={`${record.status === true ||
                                    record.enabled === true ||
                                    record.isActive === true ? "bg-primary" : "bg-secondry"}`}
                                checked={
                                    record.status === true ||
                                        record.enabled === true ||
                                        record.isActive === true
                                        ? true
                                        : false
                                }
                                onClick={() => {
                                    onDeleteData(record);
                                }}
                            />
                        </div>
                        {record.status === true ||
                            record.enabled === true ||
                            record.isActive === true ? (
                            <div
                                className="px-2 pe-auto"
                                onClick={() => {
                                    handleOpenForm(record);
                                }}
                            >
                                <BsPencilSquare size={18} />
                            </div>
                        ) : null}
                    </div>
                );
            },
        };

        if (reportName === REPORT_NAME.AGENT_MASTER && AGENT_MASTER_COLUMN) {
            AGENT_MASTER_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY && VALUE_CHAIN_CATEGORY_COLUMN) {
            VALUE_CHAIN_CATEGORY_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.VALUE_CHAIN && VALUE_CHAIN_COLUMN) {
            VALUE_CHAIN_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.DATA_PIPELINE_CATEGORY && DATA_PIPELINE_CATEGORY_COLUMN) {
            DATA_PIPELINE_CATEGORY_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.DATA_PIPELINE && DATA_PIPELINE_COLUMN) {
            DATA_PIPELINE_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.TERM_SET && TERM_SET_COLUMN) {
            TERM_SET_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.TERM && TERM_COLUMN) {
            TERM_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.DATA_RECORD && DATA_RECORDS_COLUMN && localUserObj?.userType === USER_TYPE.ADMIN) {
            DATA_RECORDS_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.VALUE_CHAIN_PARAGRAPH_EXTRACT && VALUE_CHAIN_PARAGRAPH_EXTRACT_COLULMN) {
            VALUE_CHAIN_PARAGRAPH_EXTRACT_COLULMN.map((item: any) => {
                temp.push(item);
            });
            setColumnData(temp);
        }
    }, [reportName, params.reportType]);

    useEffect(() => {
        if (reportName === REPORT_NAME.AGENT_MASTER) {
            getAllAgentMaster({
                page: currentpage - 1,
                size: pageSize,
                sort: "id",
            });
        } else if (reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY) {
            setIsCategory(true);
            getAllValueChainCategories({
                page: currentpage - 1,
                size: pageSize,
                sort: "id",
            });
        } else if (reportName === REPORT_NAME.VALUE_CHAIN) {
            setIsCategory(false);
            getAllValueChains({ page: currentpage - 1, size: pageSize, sort: "id" });
            // getAllValueChainCategories({
            //     page: currentpage - 1,
            //     size: 100,
            //     sort: "id",
            // });
        } else if (reportName === REPORT_NAME.DATA_PIPELINE_CATEGORY) {
            setIsCategory(true);
            getAllDataPipelinesCategories({
                page: currentpage - 1,
                size: pageSize,
                sort: "id",
            });
        } else if (reportName === REPORT_NAME.DATA_PIPELINE) {
            setIsCategory(false);
            getAllDataPipelines({
                page: currentpage - 1,
                size: pageSize,
                sort: "id",
            });
            // getAllDataPipelinesCategories({
            //     page: currentpage - 1,
            //     size: 100,
            //     sort: "id",
            // });
        } else if (reportName === REPORT_NAME.TERM_SET) {
            setIsCategory(true);
            getAllTermSet({ page: currentpage - 1, size: pageSize, sort: "id" });
            // getTermSetsCountName({});
        } else if (reportName === REPORT_NAME.TERM) {
            setIsCategory(false);
            getAllTerm({ page: currentpage - 1, size: pageSize, sort: "id" });
            // getAllTermSet({ page: currentpage - 1, size: 200, sort: "id" });
        } else if (reportName === REPORT_NAME.DATA_RECORD) {
            setPageSize(10);
            getAllDataRecords({
                page: currentpage - 1,
                size: 10,
                sort: "id",
            });
        } else if (reportName === REPORT_NAME.VALUE_CHAIN_PARAGRAPH_EXTRACT) {
            setPageSize(10);
            setShowAdd(false);
            getAllValueChainParagraphExtract({
                page: currentpage - 1,
                size: 10,
                sort: "id",
            });
        }
    }, [reportName]);

    useEffect(() => {
        if (call === "Y") {
            if (reportName === REPORT_NAME.AGENT_MASTER) {
                getAllAgentMaster({
                    page: currentpage - 1,
                    size: pageSize,
                    sort: "id",
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY) {
                setIsCategory(true);
                getAllValueChainCategories({
                    page: currentpage - 1,
                    size: pageSize,
                    sort: "id",
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.VALUE_CHAIN) {
                setIsCategory(false);
                getAllValueChains({
                    page: currentpage - 1,
                    size: pageSize,
                    sort: "id",
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.DATA_PIPELINE_CATEGORY) {
                setIsCategory(true);
                getAllDataPipelinesCategories({
                    page: currentpage - 1,
                    size: pageSize,
                    sort: "id",
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.DATA_PIPELINE) {
                setIsCategory(false);
                getAllDataPipelines({
                    page: currentpage - 1,
                    size: pageSize,
                    sort: "id",
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.TERM_SET) {
                setIsCategory(true);
                getAllTermSet({ page: currentpage - 1, size: pageSize, sort: "id" });
                setCall("N");
            } else if (reportName === REPORT_NAME.TERM) {
                setIsCategory(false);
                getAllTerm({ page: currentpage - 1, size: pageSize, sort: "id" });
                setCall("N");
            } else if (reportName === REPORT_NAME.DATA_RECORD) {
                setPageSize(10);
                setIsCategory(true);
                getAllDataRecords({
                    page: currentpage - 1,
                    size: 10,
                    sort: "id",
                });
                setCall("N");
            }
        }
    }, [call]);

    const paginationChange = (page: number, pageSize: number) => {
        if (reportName === REPORT_NAME.AGENT_MASTER) {
            getAllAgentMaster({
                page: page - 1,
                size: pageSize,
                sort: "id",
            });
        } else if (reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY) {
            getAllValueChainCategories({
                page: page - 1,
                size: pageSize,
                sort: "id",
            });
        } else if (reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY) {
            getAllValueChainCategories({
                page: page - 1,
                size: pageSize,
                sort: "id",
            });
        } else if (reportName === REPORT_NAME.VALUE_CHAIN) {
            getAllValueChains({
                page: page - 1,
                size: pageSize,
                sort: "id",
            });
        } else if (reportName === REPORT_NAME.DATA_PIPELINE_CATEGORY) {
            getAllDataPipelinesCategories({
                page: page - 1,
                size: pageSize,
                sort: "id",
            });
        } else if (reportName === REPORT_NAME.DATA_PIPELINE) {
            getAllDataPipelines({
                page: page - 1,
                size: pageSize,
                sort: "id",
            });
        } else if (reportName === REPORT_NAME.TERM_SET) {
            getAllTermSet({
                page: page - 1,
                size: pageSize,
                sort: "id",
            });
        } else if (reportName === REPORT_NAME.TERM) {
            getAllTerm({
                page: page - 1,
                size: pageSize,
                sort: "id",
            });
        } else if (reportName === REPORT_NAME.DATA_RECORD) {
            getAllDataRecords({
                page: page - 1,
                size: 10,
                sort: "id",
            });
        } else if (reportName === REPORT_NAME.VALUE_CHAIN_PARAGRAPH_EXTRACT) {
            getAllValueChainParagraphExtract({
                page: page - 1,
                size: 10,
                sort: "id",
            });
        }
        setCurrentPage(page);
        setPageSize(pageSize);
    };

    const handleShow = () => {
        setActionType(ACTION_TYPE.ADD_ACTION);
        setShow(true)
    };

    //delete..........
    const onDeleteData = (record: any) => {
        if (reportName === REPORT_NAME.AGENT_MASTER) {
            deleteAgentMasterById({
                id: record.id,
            });
        } else if (reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY) {
            deleteValueChainCategoryById({
                id: record.id,
            });
        } else if (reportName === REPORT_NAME.VALUE_CHAIN) {
            deleteValueChainById({
                id: record.id,
            });
        } else if (reportName === REPORT_NAME.DATA_PIPELINE_CATEGORY) {
            deleteDataPipelineCategoryById({
                id: record.id,
            });
        } else if (reportName === REPORT_NAME.DATA_PIPELINE) {
            deleteDataPipelineById({
                id: record.id,
            });
        } else if (reportName === REPORT_NAME.TERM_SET) {
            deleteTermSet({
                id: record.id,
            });
        } else if (reportName === REPORT_NAME.TERM) {
            deleteTerm({
                id: record.id,
            });
        } else if (reportName === REPORT_NAME.DATA_RECORD) {
            deleteDataRecord({
                id: record.id,
            });
        }
    };

    useEffect(() => {
        if (deleteAgentMasterByIdResponse.isSuccess) {
            if (deleteAgentMasterByIdResponse.data?.isActive) {
                alertMessage("Agent Master enable successfully", "success");
            } else {
                alertMessage("Agent Master deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteAgentMasterByIdResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteAgentMasterByIdResponse.isSuccess, deleteAgentMasterByIdResponse.isError]);


    useEffect(() => {
        if (deleteValueChainCategoryByIdResponse.isSuccess) {
            if (deleteValueChainCategoryByIdResponse.data?.isActive) {
                alertMessage("Value Chain Category enable successfully", "success");
            } else {
                alertMessage("Value Chain Category deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteValueChainCategoryByIdResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteValueChainCategoryByIdResponse.isSuccess, deleteValueChainCategoryByIdResponse.isError]);

    useEffect(() => {
        if (deleteValueChainByIdResponse.isSuccess) {
            if (deleteValueChainByIdResponse.data?.isActive) {
                alertMessage("Value Chain enable successfully", "success");
            } else {
                alertMessage("Value Chain deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteValueChainByIdResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteValueChainByIdResponse.isSuccess, deleteValueChainByIdResponse.isError,]);

    useEffect(() => {
        if (deleteTermResponse.isSuccess) {
            if (deleteTermResponse.data?.isActive) {
                alertMessage("Term enable successfully", "success");
            } else {
                alertMessage("Term deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteTermResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteTermResponse.isSuccess, deleteTermResponse.isError]);

    useEffect(() => {
        if (deleteTermSetResponse.isSuccess) {
            if (deleteTermSetResponse.data?.isActive) {
                alertMessage("Term Set enable successfully", "success");
            } else {
                alertMessage("Term Set deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteTermSetResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteTermSetResponse.isSuccess, deleteTermSetResponse.isError]);

    useEffect(() => {
        if (deleteDataPipelineCategoryByIdResponse.isSuccess) {
            if (deleteDataPipelineCategoryByIdResponse.data?.isActive) {
                alertMessage("Data Pipeline Category enable successfully", "success");
            } else {
                alertMessage("Data Pipeline Category deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteDataPipelineCategoryByIdResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteDataPipelineCategoryByIdResponse.isSuccess, deleteDataPipelineCategoryByIdResponse.isError]);

    useEffect(() => {
        if (deleteDataPipelineByIdResponse.isSuccess) {
            if (deleteDataPipelineByIdResponse.data?.isActive) {
                alertMessage("Data Pipeline enable successfully", "success");
            } else {
                alertMessage("Data Pipeline deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteDataPipelineByIdResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteDataPipelineByIdResponse.isSuccess, deleteDataPipelineByIdResponse.isError]);

    useEffect(() => {
        if (deleteDataRecordResponse.isSuccess) {
            if (deleteDataRecordResponse.data?.isActive) {
                alertMessage("Data Record enable successfully", "success");
            } else {
                alertMessage("Data Record deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteDataRecordResponse.isError) {
            alertMessage("Error while updating", "error");
        }
    }, [deleteDataRecordResponse.isSuccess, deleteDataRecordResponse.isError]);

    const handleOpenForm = (record: any) => {
        setActionType(ACTION_TYPE.UPDATE_ACTION);
        setSelectedRow(record);
        setShow(true);
    };

    useEffect(() => {
        if (allAgentMasterResponse.isSuccess) {
            dispatch(setAgentMaster(allAgentMasterResponse));
        } else if (allAgentMasterResponse.isError) {
            let response: any = allAgentMasterResponse.error;
            alertMessage(response, "error");
        }
    }, [allAgentMasterResponse.isSuccess, allAgentMasterResponse.isError]);

    //allvaluechaincategories.......
    useEffect(() => {
        if (valueChainCategoriesResponse.isSuccess) {
            dispatch(setAllValueChainCategories(valueChainCategoriesResponse));
        } else if (valueChainCategoriesResponse.isError) {
            let response: any = valueChainCategoriesResponse.error;
            alertMessage(response, "error");
        }
    }, [valueChainCategoriesResponse.isSuccess, valueChainCategoriesResponse.isError]);

    //get allvalue chains.......
    useEffect(() => {
        if (valueChainsResponse.isSuccess) {
            dispatch(setAllValueChains(valueChainsResponse));
        } else if (valueChainsResponse.isError) {
            let response: any = valueChainsResponse.error;
            alertMessage(response, "error");
        }
    }, [valueChainsResponse.isSuccess, valueChainsResponse.isError]);

    //get all terms
    useEffect(() => {
        if (getAllTermResponse.isSuccess) {
            dispatch(setAllTerm(getAllTermResponse));
        } else if (getAllTermResponse.isError) {
            let response: any = getAllTermResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllTermResponse.isSuccess, getAllTermResponse.isError]);

    //get all termset
    useEffect(() => {
        if (getTermSetResponse.isSuccess) {
            dispatch(setAllTermSet(getTermSetResponse));
        } else if (getTermSetResponse.isError) {
            let response: any = getTermSetResponse.error;
            alertMessage(response, "error");
        }
    }, [getTermSetResponse.isSuccess, getTermSetResponse.isError]);

    //get all datapipeline categories
    useEffect(() => {
        if (dataPipelinesCategoiresResponse.isSuccess) {
            dispatch(setAllDataPipelinesCategories(dataPipelinesCategoiresResponse));
        } else if (dataPipelinesCategoiresResponse.isError) {
            alertMessage("Error while fetching data", "error");
        }
    }, [dataPipelinesCategoiresResponse.isSuccess, dataPipelinesCategoiresResponse.isError]);

    //get all datapipelines
    useEffect(() => {
        if (dataPipelinesResponse.isSuccess) {
            dispatch(setAllDataPipelines(dataPipelinesResponse));
        } else if (dataPipelinesResponse.isError) {
            alertMessage("Error while fetching data", "error");
        }
    }, [dataPipelinesResponse.isSuccess, dataPipelinesResponse.isError]);

    //get all value chain paragraph extract
    useEffect(() => {
        if (valueChainParagraphExtractResponse.isSuccess) {
            dispatch(
                setAllValueChainParagraphExtractWithPagination(
                    valueChainParagraphExtractResponse
                )
            );
        } else if (valueChainParagraphExtractResponse.isError) {
            alertMessage("Error while fetching data", "error");
        }
    }, [valueChainParagraphExtractResponse.isSuccess, valueChainParagraphExtractResponse.isError]);

    //get all data records
    useEffect(() => {
        if (dataRecordsResponse.isSuccess) {
            if (allDataRecords) {
                const newerData = findNewRecords(allDataRecords && allDataRecords, dataRecordsResponse?.data?.content);
                if (newerData.length > 0) {
                    setExportData(newerData)
                } else {
                    setExportData(dataRecordsResponse?.data?.content)
                }
            }

            dispatch(setAllDataRecordsWithPagination(dataRecordsResponse));

        } else if (dataRecordsResponse.isError) {
            alertMessage("Error while fetching data", "error");
        }
    }, [dataRecordsResponse.isSuccess, dataRecordsResponse.isError]);

    const findNewRecords = (data1: any, data2: any) => {
        const newData = [];

        for (const item2 of data2) {
            let isNew = true;
            for (const item1 of data1) {
                if (item1.id === item2.id) {
                    isNew = false;
                    break;
                }
            }
            if (isNew) {
                newData.push(item2);
            }
        }

        return newData;
    };

    const buildValueChainDataSource = (data: any) => {
        let temp: any = [];
        data.forEach((element: any) => {
            // let payload =
            temp.push({
                id: element.id,
                categoryName: element?.valueChainCategoryObj ? element?.valueChainCategoryObj?.name : "-",
                agentName: element?.valueChainCategoryObj?.agentMasterObj ? element?.valueChainCategoryObj?.agentMasterObj.name : "-",
                name: element.name,
                isActive: element.isActive,
            });
        });
        setDatasource(temp);
    };

    const buildValueChainCategoryDataSource = (data: any) => {
        let temp: any = [];
        data.forEach((element: any) => {
            // let payload =
            temp.push({
                id: element.id,
                agentName: element?.agentMasterObj ? element?.agentMasterObj.name : "-",
                name: element.name,
                isActive: element.isActive,
            });
        });
        console.log(temp)
        setDatasource(temp);
    };

    const builDataPipelineDatasource = (data: any) => {
        let temp: any = [];
        data.forEach((element: any) => {
            // let payload =
            temp.push({
                id: element?.id,
                pipelineCategoryName: element?.dataPipelineCategoryObj ? element?.dataPipelineCategoryObj?.name : "-",
                name: element?.name,
                isActive: element?.isActive,
            });
        });
        setDatasource(temp);
    };

    const buildTermDatasource = (data: any) => {
        let temp: any = [];
        data.forEach((element: any) => {
            // let payload =
            temp.push({
                id: element.id,
                termsetName: element?.termSetObj ? element?.termSetObj?.name : "-",
                name: element.name,
                isActive: element.isActive,
            });
        });
        setDatasource(temp);
    };

    const buildValueChainParagraphExtractDataSource = (data: any) => {
        let temp: any = [];
        data.forEach((element: any) => {
            // let payload =
            temp.push({
                id: element?.id,
                valueChain: element.valueChainObj ? element.valueChainObj.name : "-",
                dataRecord: element.dataRecord,
                dataContentLink: element?.dataRecordObj ? element?.dataRecordObj?.dataContentLink : "-",
                paragraphContent: element.paragraphContent,
                isActive: element.isActive,
            });
        });
        setDatasource(temp);
    };

    const buildDataRecord = (data: any) => {
        let temp: any = [];
        data.forEach((element: any) => {
            // let payload =
            temp.push({
                id: element.id,
                dataContentLink:
                    element.dataContentLink === null ? "-" : element.dataContentLink,
                dataContent: element.dataContent === null || element.dataContent === "" ? "-" : element.dataContent,
                dataQualityStatus:
                    element.dataQualityStatus === null ? "-" : element.dataQualityStatus,
                country: element.country === null ? "-" : element.country,
                state: element.state === null ? "-" : element.state,
                city: element.city === null || element.city === "" ? "-" : element.city,
                district: element.district === null ? "-" : element.district,
                createdOn:
                    element.createdDate === null ? "-" : fDateTimeSuffix(element.createdDate),
                isActive: element.isActive,
                valueChainCategoryName: element.valueChainCategoryName === null ? "-" : element.valueChainCategoryName,
                valueChainName: element.valueChainName === null ? "-" : element.valueChainName,
                termSetName: element.termSetName === null ? "-" : element.termSetName
            });
        });
        setDatasource(temp);
        setFilterTableForDataRecord(temp);
    };

    //data

    useEffect(() => {
        if (allAgentMaster && reportName === REPORT_NAME.AGENT_MASTER) {
            setDatasource(allAgentMaster);
        }
    }, [allAgentMaster]);

    useEffect(() => {
        if (allValueChains && reportName === REPORT_NAME.VALUE_CHAIN) {
            buildValueChainDataSource(allValueChains)
        }
    }, [allValueChains]);

    useEffect(() => {
        if (allValueChainCategories && reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY) {
            buildValueChainCategoryDataSource(allValueChainCategories);
        }
    }, [allValueChainCategories]);

    useEffect(() => {
        if (allTerm && reportName === REPORT_NAME.TERM) {
            buildTermDatasource(allTerm);
        }
    }, [allTerm]);

    useEffect(() => {
        if (allTermSet && reportName === REPORT_NAME.TERM_SET) {
            setDatasource(allTermSet);
        }
    }, [allTermSet]);

    useEffect(() => {
        if (allDataPipelineCategories && reportName === REPORT_NAME.DATA_PIPELINE_CATEGORY) {
            setDatasource(allDataPipelineCategories);
        }
    }, [allDataPipelineCategories]);


    useEffect(() => {
        if (allDataPipeline && reportName === REPORT_NAME.DATA_PIPELINE) {
            builDataPipelineDatasource(allDataPipeline);
        }
    }, [allDataPipeline]);

    useEffect(() => {
        if (allValueChainParagraphExtract && reportName === REPORT_NAME.VALUE_CHAIN_PARAGRAPH_EXTRACT) {
            buildValueChainParagraphExtractDataSource(allValueChainParagraphExtract);
        }
    }, [allValueChainParagraphExtract]);

    useEffect(() => {
        if (allDataRecords && reportName === REPORT_NAME.DATA_RECORD) {
            buildDataRecord(allDataRecords);
        }
    }, [allDataRecords]);

    const onSearchChange = (e: RadioChangeEvent) => {
        setSearchValue(e.target.value);
    };

    const handleSearch = (event: any) => {
        // console.log((event.target.value).length)
        // if ((event.target.value).length >= 3) {
        if (reportName === REPORT_NAME.AGENT_MASTER) {
            getAllAgentMasterWithSearch({
                token: token,
                payload: { offset: 100, pageNumber: 0, searchBy: event.target.value },
            });
        } else if (reportName === REPORT_NAME.TERM) {
            getAllTermWithSearch({
                token: token,
                payload: { offset: 100, pageNumber: 0, searchBy: event.target.value },
            });
        } else if (reportName === REPORT_NAME.TERM_SET) {
            getAllTermSetWithSearch({
                token: token,
                payload: { offset: 100, pageNumber: 0, searchBy: event.target.value },
            });
        } else if (reportName === REPORT_NAME.VALUE_CHAIN) {
            getAllValueChainWithSearch({
                token: token,
                payload: { offset: 100, pageNumber: 0, searchBy: event.target.value },
            });
        } else if (reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY) {
            getAllValueChainCategoryWithSearch({
                token: token,
                payload: { offset: 100, pageNumber: 0, searchBy: event.target.value },
            });
        } else if (reportName === REPORT_NAME.DATA_PIPELINE) {
            getAllDataPipelineWithSearch({
                token: token,
                payload: { offset: 100, pageNumber: 0, searchBy: event.target.value },
            });
        } else if (reportName === REPORT_NAME.DATA_PIPELINE_CATEGORY) {
            getAllDataPipelineCategoryWithSearch({
                token: token,
                payload: { offset: 100, pageNumber: 0, searchBy: event.target.value },
            });
        } else if (reportName === REPORT_NAME.DATA_RECORD) {
            if (searchValue === 1) {
                getAllDataRecordWithSearch({
                    token: token,
                    payload: { offset: 10, pageNumber: 0, searchBy: event.target.value },
                });
            } else if (searchValue === 2) {

                if (event.target.value !== "") {
                    const filterTable: any = dataSource.filter((o: any) =>
                        Object.keys(o).some(k =>
                            String(o[k])
                                .toLowerCase()
                                .includes((event.target.value).toLowerCase())
                        )
                    );
                    setFilterTableForDataRecord(filterTable);
                } else {
                    setFilterTableForDataRecord(dataSource)
                }
            }
        } else if (reportName === REPORT_NAME.VALUE_CHAIN_PARAGRAPH_EXTRACT) {
            getAllValueChainParagraphExtractWithSearch({
                token: token,
                payload: { offset: 10, pageNumber: 0, searchBy: event.target.value },
            });
        }
        // }
    };

    useEffect(() => {
        if (getAllAgentMasterWithSearchResponse.isSuccess) {
            dispatch(setAgentMasterBySearch(getAllAgentMasterWithSearchResponse));
        } else if (getAllAgentMasterWithSearchResponse.isError) {
            let response: any = getAllAgentMasterWithSearchResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllAgentMasterWithSearchResponse.isSuccess, getAllAgentMasterWithSearchResponse.isError]);

    useEffect(() => {
        if (getAllDataPipelineWithSearchResponse.isSuccess) {
            dispatch(setAllDataPipelinesBySearch(getAllDataPipelineWithSearchResponse));
        } else if (getAllDataPipelineWithSearchResponse.isError) {
            let response: any = getAllDataPipelineWithSearchResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllDataPipelineWithSearchResponse.isSuccess, getAllDataPipelineWithSearchResponse.isError]);

    useEffect(() => {
        if (getAllDataPipelineCategoryWithSearchResponse.isSuccess) {
            dispatch(setAllDataPipelinesCategoriesBySearch(getAllDataPipelineCategoryWithSearchResponse));
        } else if (getAllDataPipelineCategoryWithSearchResponse.isError) {
            let response: any = getAllDataPipelineCategoryWithSearchResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllDataPipelineCategoryWithSearchResponse.isSuccess, getAllDataPipelineCategoryWithSearchResponse.isError]);

    useEffect(() => {
        if (getAllValueChainWithSearchResponse.isSuccess) {
            dispatch(setAllValueChainsBySearch(getAllValueChainWithSearchResponse));
        } else if (getAllValueChainWithSearchResponse.isError) {
            let response: any = getAllValueChainWithSearchResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllValueChainWithSearchResponse.isSuccess, getAllValueChainWithSearchResponse.isError]);

    useEffect(() => {
        if (getAllValueChainCategoryWithSearchResponse.isSuccess) {
            dispatch(setAllValueChainCategoriesBySearch(getAllValueChainCategoryWithSearchResponse));
        } else if (getAllValueChainCategoryWithSearchResponse.isError) {
            let response: any = getAllValueChainCategoryWithSearchResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllValueChainCategoryWithSearchResponse.isSuccess, getAllValueChainCategoryWithSearchResponse.isError]);

    useEffect(() => {
        if (getAllTermSetWithSearchResponse.isSuccess) {
            dispatch(setAllTermSetBySearch(getAllTermSetWithSearchResponse));
        } else if (getAllTermSetWithSearchResponse.isError) {
            let response: any = getAllTermSetWithSearchResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllTermSetWithSearchResponse.isSuccess, getAllTermSetWithSearchResponse.isError]);

    useEffect(() => {
        if (getAllTermWithSearchResponse.isSuccess) {
            dispatch(setAllTermBySearch(getAllTermWithSearchResponse));
        } else if (getAllTermWithSearchResponse.isError) {
            let response: any = getAllTermWithSearchResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllTermWithSearchResponse.isSuccess, getAllTermWithSearchResponse.isError]);

    useEffect(() => {
        if (getAllDataRecordWithSearchResponse.isSuccess) {
            dispatch(setAllDataRecordsBySearch(getAllDataRecordWithSearchResponse));
        } else if (getAllDataRecordWithSearchResponse.isError) {
            let response: any = getAllDataRecordWithSearchResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllDataRecordWithSearchResponse.isSuccess, getAllDataRecordWithSearchResponse.isError]);

    useEffect(() => {
        if (getAllValueChainParagraphExtractWithSearchResponse.isSuccess) {
            dispatch(setAllValueChainParagraphExtractBySearch(getAllValueChainParagraphExtractWithSearchResponse));
        } else if (getAllValueChainParagraphExtractWithSearchResponse.isError) {
            let response: any = getAllValueChainParagraphExtractWithSearchResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllValueChainParagraphExtractWithSearchResponse.isSuccess, getAllValueChainParagraphExtractWithSearchResponse.isError]);

    useEffect(() => {
        if (allAgentMasterBySearch && reportName === REPORT_NAME.AGENT_MASTER) {
            setDatasource(allAgentMasterBySearch);
        }
    }, [allAgentMasterBySearch]);

    useEffect(() => {
        if (allValueChainsBySearch && reportName === REPORT_NAME.VALUE_CHAIN) {
            buildValueChainDataSource(allValueChainsBySearch);
        }
    }, [allValueChainsBySearch]);

    useEffect(() => {
        if (allValueChainCategoriesBySearch && reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY) {
            buildValueChainCategoryDataSource(allValueChainCategoriesBySearch);
        }
    }, [allValueChainCategoriesBySearch]);

    useEffect(() => {
        if (allTermBySearch && reportName === REPORT_NAME.TERM) {
            buildTermDatasource(allTermBySearch);
        }
    }, [allTermBySearch]);

    useEffect(() => {
        if (allTermSetBySearch && reportName === REPORT_NAME.TERM_SET) {
            setDatasource(allTermSetBySearch);
        }
    }, [allTermSetBySearch]);

    useEffect(() => {
        if (allDataPipelineCategoriesBySearch && reportName === REPORT_NAME.DATA_PIPELINE_CATEGORY) {
            setDatasource(allDataPipelineCategoriesBySearch);
        }
    }, [allDataPipelineCategoriesBySearch]);

    useEffect(() => {
        if (allDataPipelineBySearch && reportName === REPORT_NAME.DATA_PIPELINE) {
            builDataPipelineDatasource(allDataPipelineBySearch);
        }
    }, [allDataPipelineBySearch]);

    useEffect(() => {
        if (allValueChainParagraphExtractBySearch && reportName === REPORT_NAME.VALUE_CHAIN_PARAGRAPH_EXTRACT) {
            buildValueChainParagraphExtractDataSource(allValueChainParagraphExtractBySearch);
        }
    }, [allValueChainParagraphExtractBySearch]);

    useEffect(() => {
        if (allDataRecordsBySearch && reportName === REPORT_NAME.DATA_RECORD) {
            buildDataRecord(allDataRecordsBySearch);
        }
    }, [allDataRecordsBySearch]);

    return (
        <div className="mt-2 overflow-y-auto">
            <div className="d-flex align-items-center justify-content-between flex-sm-row flex-column mb-2">
                <div className="d-flex align-items-center w-100 px-2">
                    <h5
                        className="m-0 px-0 d-flex align-items-center text-cm-active-primary1"
                        style={{ fontWeight: "700" }}
                    >
                        {reportName}
                    </h5>
                </div>
                <div className="d-flex align-items-center justify-content-start justify-content-sm-end cursor-pointer w-100">
                    <div className="d-flex flex-column">
                        <div className="input-group px-2 mt-1">
                            <Form.Control
                                type="search"
                                placeholder="Search"
                                className="border-0 bg-cm-light-primary1"
                                aria-label="Search"
                                onChange={handleSearch}
                            />
                            <div className="input-group-append bg-cm-light-primary1 p-1 rounded-end">
                                <span className="input-group-text bg-cm-light-primary1 border-0">
                                    {/* <img src={gear} alt="" /> */}
                                    <BsSearch className=" bg-cm-light-primary1 border-cm-light-primary1" />
                                </span>
                            </div>
                        </div>
                        {reportName === REPORT_NAME.DATA_RECORD ? (
                            <Radio.Group onChange={onSearchChange} value={searchValue} className="mt-1 px-2">
                                <Radio value={1}>Comprehensive Search</Radio>
                                <Radio value={2}>Web Search</Radio>
                            </Radio.Group>
                        ) : null}
                    </div>
                    {reportName !== REPORT_NAME.VALUE_CHAIN_PARAGRAPH_EXTRACT && (
                        <div className="d-flex px-2 align-items-center mt-1">
                            <Button
                                variant="primary"
                                className="d-flex align-items-center me-0 text-nowrap"
                                onClick={handleShow}
                            >
                                <BsPlus />
                                {reportName === REPORT_NAME.DATA_RECORD ? "Web Search" : "Add"}
                            </Button>
                        </div>
                    )}
                    {dataRecordsResponse.isLoading ||
                        valueChainCategoriesResponse.isLoading ||
                        valueChainsResponse.isLoading ||
                        getAllTermResponse.isLoading ||
                        getTermSetResponse.isLoading ||
                        dataPipelinesCategoiresResponse.isLoading ||
                        dataPipelinesResponse.isLoading ||
                        valueChainParagraphExtractResponse.isLoading ? (
                        <Loading />
                    ) : (
                        ""
                    )}
                    {show && (
                        <MasterReportData
                            show={show}
                            setShow={setShow}
                            actionType={actionType}
                            reportName={reportName}
                            data={selectedRow}
                            setCall={setCall}
                            isCategory={isCategory}
                        />
                    )}
                </div>
            </div>
            <div className="mt-3 my-2 w-100 overflow-x-auto rounded-3">
                <Table
                    bordered={true}
                    rowKey={"id"}
                    scroll={{ x: 'max-content' }}
                    tableLayout="fixed"
                    pagination={{
                        total: (() => {
                            switch (reportName) {
                                case REPORT_NAME.AGENT_MASTER:
                                    return totalAgentMaster;
                                case REPORT_NAME.VALUE_CHAIN_CATEGORY:
                                    return totalValueChainCategory;
                                case REPORT_NAME.VALUE_CHAIN:
                                    return totalValueChain;
                                case REPORT_NAME.DATA_PIPELINE_CATEGORY:
                                    return totalDatapipelineCategory;
                                case REPORT_NAME.DATA_PIPELINE:
                                    return totalDatapipeline;
                                case REPORT_NAME.TERM_SET:
                                    return totalTermSet;
                                case REPORT_NAME.TERM:
                                    return totalTerms;
                                case REPORT_NAME.DATA_RECORD:
                                    return totalDataRecords;
                                case REPORT_NAME.VALUE_CHAIN_PARAGRAPH_EXTRACT:
                                    return totalValueChainParagraphExtract;
                                default:
                                    return dataSource.length;
                            }
                        })(),
                        responsive: true,
                        current: currentpage,
                        // showSizeChanger: true,  
                        pageSizeOptions: [10, 20, 30],
                        onChange: (page, pageSize) => {
                            paginationChange(page, pageSize);
                        },
                        pageSize: pageSize,
                    }}
                    columns={columData}
                    dataSource={dataSource}
                />
            </div>
        </div>
    );
};
export default DataSourceMangement;